/**
 * Traduções de lista de mensagens
 * Inclui: Texto de estado vazio, etc.
 */
export default {
  emptyNormal: 'Nenhuma mensagem ainda',
  emptyStranger: 'Nenhuma mensagem de estranhos ainda',
  emptyFollow: 'Nenhum seguidor ainda'
}
